(() => {
  const normalize = (value) => (value || '')
    .toLocaleLowerCase('tr-TR')
    .replace(/\s+/g, ' ')
    .trim();

  const setup = () => {
    document.querySelectorAll('.facets-wrapper').forEach((facets) => {
      if (!facets.querySelector('.ep-filter-reset')) {
        const reset = document.createElement('a');
        reset.className = 'ep-filter-reset';
        reset.href = window.location.pathname;
        reset.innerHTML = '<span aria-hidden="true">×</span><span>FİLTRELERİ TEMİZLE</span><span class="ep-filter-reset__funnel" aria-hidden="true">▽</span>';
        facets.prepend(reset);
      }

      facets.querySelectorAll('.facets__panel').forEach((panel) => {
        const summary = panel.querySelector('.facets__summary');
        const body = panel.querySelector('.facets__display-vertical');
        if (!summary || !body || body.querySelector('.ep-brand-search')) return;
        const label = normalize(summary.textContent);
        if (!(label.includes('marka') || label.includes('brand') || label.includes('vendor'))) return;

        const wrap = document.createElement('div');
        wrap.className = 'ep-brand-search';
        wrap.innerHTML = '<span aria-hidden="true">⌕</span><input type="search" placeholder="Marka ara..." aria-label="Marka ara">';
        body.prepend(wrap);
        const input = wrap.querySelector('input');
        input.addEventListener('input', () => {
          const q = normalize(input.value);
          body.querySelectorAll('.facets__item').forEach((item) => {
            const text = normalize(item.textContent);
            item.hidden = !!q && !text.includes(q);
          });
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', setup);
  document.addEventListener('shopify:section:load', setup);
  new MutationObserver(setup).observe(document.documentElement, { childList: true, subtree: true });
  setup();
})();
